module.exports = __webpack_public_path__ + "media/images/weather/117_night-d9799e904608bb935cf6d827545391f7.png";